import React from 'react'
import NumberFormat  from 'react-number-format'

export const numberFormat = (value, allowNegative = false,decimalScale=2) => {
  return (
  <NumberFormat 
    className='centerContent' 
    thousandSeparator=',' 
    value={value} 
    displayType='text'
    decimalScale={decimalScale}
    allowNegative={allowNegative}
    fixedDecimalScale />
  )
}